import { render, staticRenderFns } from "./ReviewTerms.vue?vue&type=template&id=94fa6040"
import script from "./ReviewTerms.vue?vue&type=script&lang=ts"
export * from "./ReviewTerms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports